
import { EShopCategory } from '~/src/api/content/shop/getShopItems';
import FullBuyAnalytics from '~/src/features/full-buy/analytics';
import { getLimits } from '~/src/features/full-buy/helpersForProducts';
import { isInstallment } from '~/src/features/full-buy/helpersForProducts';
import { decProductQuantity, incProductQuantity } from '~/src/features/full-buy/store/actions';
import { selectProductsByCategory } from '~/src/features/full-buy/store/selectors/products/selectProductsByCategory';
import { TAppThunkDispatch, TGetState } from '~/src/store';

/**
 * Увеличивает/уменьшает количество для выбранного оборудования
 */
export const changeEquipmentCount = (elementId: number, isIncrement: boolean, category: EShopCategory, analytics: FullBuyAnalytics) => {
    return async(dispatch: TAppThunkDispatch, getState: TGetState): Promise<void> => {
        const state = getState();

        const products = selectProductsByCategory(state, category);

        const currentEl = products.find(el => el.id === elementId);
        const limits = getLimits(products, category);

        if (!currentEl) {
            return;
        }

        if (isIncrement) {
            // Если достигнут общий лимит или лимит по покупке в рассрочку, то не увеличиваем количество
            if (limits.total || (isInstallment(currentEl) && limits.installment)) {
                return;
            }

            dispatch(incProductQuantity(elementId));
        } else {
            dispatch(decProductQuantity(elementId));

            if (currentEl.quantity === 1) {
                analytics.equipment.deleteEquipment(currentEl.title);
            }
        }
    };
};
